/* eslint-disable max-len */
import React, { useState } from "react";
import { useUserSubscription } from "../../helper/hooks";
import "./christmas-offer.m.css";
import { SubscriberOnlyNudge } from "./subscriber-only-nudge";

const ChristmasOfferPage = () => {
  const userSubscription = useUserSubscription();
  const [showDialog, setShowDialog] = useState(false);
  const subscriptionLoading = userSubscription.loading;

  const handleBuyNow = planId => () => {
    window.open(`https://razorpay.com/payment-button/${planId}/view`, "_blank");
  };

  return (
    <div styleName="wrapper">
      <h1 styleName="title">Christmas with Newslaundry</h1>
      <br />
      <div styleName="top-wrapper">
        <div styleName="img-wrap">
          <img
            alt="banner"
            src="https://images.assettype.com/newslaundry/2022-01/aaa72797-14d9-4b87-8186-1edf269915af/christmas_campaign_no_date.jpg"
          />
        </div>
        <div styleName="text-wrap">
          <p styleName="description">
            {" "}
            This festive season, be the Santa for free press. With our Christmas
            offer, get your favourite NL masks, Karare Chane mugs, soap sets and
            a lot more on discount. And besides each customised NL gift hamper,
            there is a free giftable subscription too, for your friends and
            family.
            <br />
            <br />
            Get our merchandise for yourself and say you’re a proud member of a
            community that keeps independent media alive. Or give these to
            friends and family, and spread the word about free, accurate and
            independent news.
            <br />
          </p>
        </div>
      </div>
      <br />
      <div styleName="hamper__container">
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper One</h2>
          {/* <img
            alt=""
            src="https://images.assettype.com/newslaundry/2021-10/c367c9d9-a6ca-42f9-92b3-72df7fb187e7/Diwali_Hamper_1_2__.jpg"
            // style={{ margin: "-90px" }}
          /> */}
          {/* <div styleName="hamper__hr"></div> */}
          <ul>
            <li>
              <span>❄️</span>
              <span>Mask</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Fridge Magnet</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Which Naxal Are You Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Gift 2x One Month Disruptor Subscriptions</span>
            </li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>920
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_IYBOHEk0HRQUjf")}>Buy Now</button>
          )}
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper Two</h2>
          {/* <img
            alt=""
            src="https://images.assettype.com/newslaundry/2021-10/ec1a2962-f4e7-479c-a983-9b16c2fbe4fc/Diwali_Hamper_2_2_.jpg"
            // style={{ margin: "-75px" }}
          /> */}
          {/* <div styleName="hamper__hr"></div> */}
          <ul>
            <li>
              <span>❄️</span>
              <span>Mask</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Flask</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Karare Chane Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Laptop Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Fridge Magnets</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Gift 3x One Month Disruptor Subscriptions</span>
            </li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>1,520
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_IYBW6A74N2QPCP")}>Buy Now</button>
          )}
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper Three</h2>
          {/* <img
            alt=""
            src="https://images.assettype.com/newslaundry/2021-10/acaa0e7a-7c68-4dbb-a6ce-9b20c46843d7/Diwali_Hamper_3_2_.jpg"
            // style={{ marginTop: "-5px" }}
          /> */}
          {/* <div styleName="hamper__hr"></div> */}

          <ul>
            <li>
              <span>❄️</span>
              <span>Mask</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Fridge Magnets</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Flask</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Soap Set</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Karare Chane Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Which Naxal Are You Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Laptop Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Car Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Gift 2x Six Months Disruptor Subscriptions</span>
            </li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>2,320
          </h2>
          {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_IYBZpaOSEmtEcO")}>Buy Now</button>
          )}
        </div>
      </div>
      <div>
        <strong>Terms &amp; Conditions</strong>
      </div>

      <ul styleName="notes_wrapper">
        <li>
          This is a limited period offer from December 17th, 2021 to January
          6th, 2022.
        </li>
        <li>Delivery in India only. </li>
        <li>
          If you are based overseas, please share an Indian delivery address (of
          friends/family).
        </li>
        <li>
          Please note, delivery of packages will take at least two to three
          weeks. Thank you for your patience.
        </li>
        <li>
          We will manually map the gift subscriptions. The subscription will be
          mapped within 48 hours.
        </li>
        <li>
          If you have any queries, please drop an email on{" "}
          <a style={{ color: "#ec2227" }} href="mailto:store@newslaundry.com">
            store@newslaundry.com
          </a>
        </li>
      </ul>
      <br />
      {showDialog ? (
        <SubscriberOnlyNudge handleClose={() => setShowDialog(false)} />
      ) : null}
    </div>
  );
};

export { ChristmasOfferPage };
